import { render } from "./DialogBookRefundError.vue?vue&type=template&id=46c1072a"
import script from "./DialogBookRefundError.vue?vue&type=script&lang=js"
export * from "./DialogBookRefundError.vue?vue&type=script&lang=js"
script.render = render

export default script